module.exports = __webpack_public_path__ + "static/media/file_copy-24px.af0d3034.svg";